import { createAction, props } from '@ngrx/store';
import { Order } from '@app/services/order/order.model';
import { QueryParameters } from '@app/core/entities/query-parameters.class';

const actionPrefix = '[Deleted][Orders]';

export const loadDeletedOrders = createAction(`${actionPrefix} Load`, props<{ queryParameters: QueryParameters }>());
export const loadDeletedOrdersSuccess = createAction(
  `${actionPrefix} Load Success`,
  props<{ orders: Order[]; count: number }>(),
);
export const loadDeletedOrdersFailure = createAction(`${actionPrefix} Load Failure`);

export const setDeletedOrdersLoading = createAction(`${actionPrefix} Set Loading`, props<{ loading: boolean }>());

// restore orders
export const restoreOrders = createAction(`${actionPrefix} Restore order`, props<{ ordersId: string[] }>());
export const restoreOrdersSuccess = createAction(`${actionPrefix} Restore order sucess`);
export const restoreOrdersFailure = createAction(`${actionPrefix} Restore order failure`);
